<template>

  <div class="client-select">

    <multiselect
        ref="select"
        v-model="selectedOption"
        :options="options"
        :loading="loading"
        :internal-search="false"
        :clearable="clearable"
        :placeholder="placeholder"
        :label="labelKey"
        :track-by="valueKey"
        @search-change="onSearch"
    >

      <template #beforeList>
        <li class="multiselect__element">
        <span class="create-item" @click.stop="openCreateModal">
          ➕ Создать клиента
        </span>
        </li>
      </template>

      <template #noResult>
        <span v-if="!loading">Ничего не найдено</span>
        <span v-else>Загрузка...</span>
      </template>

    </multiselect>

    <ClientFormModal
        :show="showModal"
        @saved="clientCreated"
        @close="showModal=false"
    />

  </div>

</template>

<script>
import axios from "@/axios"
import Multiselect from "vue-multiselect"
import ClientFormModal from "@/views/components/Form/ClientFormModal.vue"

export default {
  name: "ClientSelect",

  components: {
    Multiselect,
    ClientFormModal
  },

  props: {
    modelValue: null,
    clearable: { default: true },
    placeholder: { default: "Выберите клиента" },
    valueKey: { default: "id" },
    labelKey: { default: "fullName" }
  },

  emits: ["update:modelValue"],

  data() {
    return {
      options: [],
      loading: false,
      selectedOption: null,
      showModal: false,
      search: ""
    }
  },

  watch: {
    modelValue: {
      immediate: true,
      async handler(val) {
        if (!val) {
          this.selectedOption = null
          return
        }

        const found = this.options.find(
            o => o[this.valueKey] === val
        )

        if (found) {
          this.selectedOption = found
          return
        }

        try {
          const { data } = await axios.get("/api/clients/" + val)
          const client = data.data || data

          if (!client) return

          const exists = this.options.find(
              o => o[this.valueKey] === client[this.valueKey]
          )

          if (!exists) {
            this.options.unshift(client)
          }

          this.selectedOption = client
        } catch (e) {
          console.error("Ошибка загрузки клиента по id:", e)
        }
      }
    },

    selectedOption(val) {
      if (!val) {
        this.$emit("update:modelValue", null)
        return
      }

      this.$emit("update:modelValue", val[this.valueKey])
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    async load(search = "") {
      this.loading = true

      try {
        const { data } = await axios.get("/api/clients", {
          params: {
            search: search,
            start: 0,
            length: 20
          }
        })

        this.options = data

        if (this.modelValue) {
          const found = this.options.find(
              o => o[this.valueKey] === this.modelValue
          )

          if (found) {
            this.selectedOption = found
          }
        }
      } finally {
        this.loading = false
      }
    },

    async loadOptionById(id) {
      try {
        const { data } = await axios.get("/api/clients/" + id)
        const client = data.data || data

        if (!client) {
          return
        }

        const exists = this.options.find(
            o => o[this.valueKey] === client[this.valueKey]
        )

        if (!exists) {
          this.options.unshift(client)
        }

        this.selectedOption = client
      } catch (e) {
        console.error("Ошибка загрузки клиента по id:", e)
      }
    },

    onSearch(query) {
      this.search = query
      this.load(query)
    },

    openCreateModal() {
      this.$refs.select.deactivate()
      this.showModal = true
    },

    clientCreated(client) {
      this.showModal = false

      if (!client) return

      const exists = this.options.find(
          o => o[this.valueKey] === client[this.valueKey]
      )

      if (!exists) {
        this.options.unshift(client)
      }

      this.selectedOption = client
      this.$emit("update:modelValue", client[this.valueKey])
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>

.create-item {
  display: block;
  padding: 10px;
  cursor: pointer;
  font-weight: 600;
  border-bottom: 1px solid #eee;
}

.create-item:hover {
  background: #f5f5f5;
}

</style>